import React from "react";
import { withRouter } from "react-router";
import { DATE_FORMAT, PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import GridFw, { COLUMN_DEFAULT } from '../../../../../framework/grid/GridFw';  
import { MessageUtil } from '../../../../../util/MessageUtil';
import { DatosAnalisisModal } from "../modals/DatosAnalisisModal";
import { Row, Col } from "antd"; 
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { EnvConstants } from '../../../../../EnvConstants';
import { LoadingUtil } from '../../../../../util/LoadingUtil';
import { ReportUtil } from "../../../../../util/ReportUtil";
 
class ResumenCompraSection extends BasePage {
    renderPage(pageApi) {
     
    const getgridDatAnalisis_resumen_visible = () => pageApi.getComponent("gridDatAnalisis_resumen_visible");
    const getgridDatAnalisis_resumen = () => pageApi.getComponent("gridDatAnalisis_resumen");
    const getFormresumencompras = () => pageApi.getComponent("formSumas");
   
    const calculateTotal = () => {
    let items = getgridDatAnalisis_resumen().getData(); 
    if (items) {
      let total = 0;
      let vuelta_gasto_operativo = 0;
      let total_gasto_operativo = 0; 
      let simb_moneda = "";
      items.forEach((item) => {
        total =
          total +
          (isNaN(parseFloat(item.sub_total)) ? 0 : parseFloat(item.sub_total));
        if(vuelta_gasto_operativo == 0){
          if(item.gasto_operativo == null) {
            total_gasto_operativo = 0;
            simb_moneda = item.simb_moneda
          }
          else {
            total_gasto_operativo = item.gasto_operativo;
            simb_moneda = item.simb_moneda
          }    
          vuelta_gasto_operativo = 1; 
        }  
      });

      let total_analisis = parseFloat(total); 
      let servicio_analisis = isNaN(total_analisis) ? 0 : total_analisis.toFixed(2);
      let gastos_operativos = isNaN(total_gasto_operativo) ? 0 : total_gasto_operativo.toFixed(2);
      let subtotalservicio = (parseFloat(servicio_analisis) + parseFloat(gastos_operativos)).toFixed(2);
      let txt_IGV = parseFloat(parseFloat(subtotalservicio) * 0.18).toFixed(2);
      let txt_total_servicio = parseFloat(parseFloat(servicio_analisis) + parseFloat(gastos_operativos) + parseFloat(txt_IGV)).toFixed(2);

      getFormresumencompras().setFieldData("sub_total_analisis",(simb_moneda + ' ' + servicio_analisis));
      getFormresumencompras().setFieldData("sub_total_gasto_operativo",(simb_moneda + ' ' + gastos_operativos));  
      getFormresumencompras().setFieldData("sub_total_final",(simb_moneda + ' ' + subtotalservicio)); 
      getFormresumencompras().setFieldData('sub_total_IGV',(simb_moneda + ' ' + txt_IGV));
      getFormresumencompras().setFieldData('sub_total_servicios',(simb_moneda + ' ' + txt_total_servicio));  
    }
  };
 
  const gridDatAnalisis_resumen_visible = {
    title: "RESUMEN DE COTIZACION",
    rowId: "id_rel_cot_ana",
    showIndex: true,
    pagination: {
      server: false,
      showSizeChanger: true,
    },
    autoLoad: true,
    collapsible: true,
    orderBy: "descripcion_grupo",
    load: {
      validation: () => pageApi.getParamId() != null, //solo se dispara si el valor es distinto de nulo
      queryId: 859,
      params: { id_doc: pageApi.getParamId() },
      hideMessage: true,
      hideMessageError: true,
      fnOk: (resp) => {
        calculateTotal();
      },
    },
 
    fields: [
      { name: "descripcion_grupo", label: "Descripcion" }, 
      { name: "mat_nombre", label: "Matriz" }, 
      { name: "simb_moneda", label: "Moneda" }, 
      {
        type: "decimal",
        name: "sub_total",
        label: "Total",
        // editable: true,
        // readOnly: true,
      },  
    ], 
  };

  const gridDatAnalisis_resumen = {
    title: "RESUMEN DE COTIZACION",
    rowId: "id_rel_cot_ana",
    showIndex: true,
    pagination: {
      server: false,
      showSizeChanger: true,
    },
    autoLoad: true,
    collapsible: true,
    orderBy: "descripcion_grupo",
    load: {
      validation: () => pageApi.getParamId() != null, //solo se dispara si el valor es distinto de nulo
      queryId: 194,
      params: { id_doc: pageApi.getParamId() },
      hideMessage: true,
      hideMessageError: true,
      fnOk: (resp) => {
        calculateTotal();
      },
    },
 
    fields: [
      { name: "descripcion_grupo", label: "Descripcion" }, 
      { name: "mat_nombre", label: "Matriz" }, 
      {
        type: "decimal",
        name: "sub_total",
        label: "Total",
        editable: true,
        readOnly: true,
      },  
    ], 
  };
 
    const barButtonFooter_DatAnalisis = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN,label: 'Retornar al Inicio', link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
            {...COLUMN_DEFAULT.DOWNLOAD,label: 'Descargar Cotizacion', color:'black', colSpan: 0, onClick: (value, row, index)=> 
                {         
                    LoadingUtil.loadShow();

                    let url = EnvConstants.GET_REPORT2_URL() + 'CotizacionMa';     
                    ReportUtil.donwloadFromPost(url, {queryId: 858, params: {id_doc: pageApi.getParamId()}},
                      "Cotizacion_Pendiente_"+ getgridDatAnalisis_resumen().getData()[0].doc_nro?.trim() +".pdf").then(x => {
                        LoadingUtil.loadHide();
                    }).catch(x => {
                        console.error(x)
                        LoadingUtil.loadHide(); 
                    });
                }   
            },
            { ...BUTTON_DEFAULT.SAVE,label: 'Realizar Pago', onClick: () => { 
                   LoadUtil.loadByQueryId({
                   url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                   queryId: 817,
                   //SE COLOCA ID_SS YA QUE ES UN REUTILIZABLE EN LA TABLA SE INSERA LA COTI Y LA SS
                   params: { id_SS: pageApi.getParamId(), est_tab : 6, id_user: UserUtil.getUserId()},
                   fnOk: (resp) => { 
                      const id_doc = resp.dataObject?.id_doc;  
                      const est_tab_actual = resp.dataObject?.est_tab;    

                      if(est_tab_actual == 6){
                      this.props.history.push(`/cotizaciones/cotizaciones/6/${id_doc}`)
                      }
          

                      this.props.cambiarTabPanel("6",pageApi.getParamId()); 
                      return MessageUtil(
                        "success",
                        "Exito!",
                        "Se ha habilitado Pago de Servicio"
                      ); 
                   }
                   }) 
             } }, 
        ]
    }

    const form_sumas = {
      fields: [
      { name: "sub_total_analisis",label: "Servicio de Analisis",column: 12,readOnly: true,}, 
      { name: "sub_total_gasto_operativo",label: "Gastos Operativos",column: 12, readOnly: true,},  
      { name: "sub_total_final",label: "Sub Total del Servicio", column: 12, readOnly: true, },  
      { name: "sub_total_IGV",label: "IGV", column: 12, readOnly: true, },  
      { name: "sub_total_servicios",label: "Total del Servicio",column: 12, readOnly: true,},  
      ],
    };

    return (
      <> 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_DatAnalisis} 
        /> 
        <div style={{ maxWidth: '650px', margin: 'auto', border: '1px solid #919191ff', borderRadius: '9px', overflow: 'hidden' }}>
          <GridFw
            name="gridDatAnalisis_resumen_visible"
            getParentApi={pageApi.getApi}
            config={gridDatAnalisis_resumen_visible}
          />
          <div style={{ display: 'none' }}>
            <GridFw
              name="gridDatAnalisis_resumen"
              getParentApi={pageApi.getApi}
              config={gridDatAnalisis_resumen}
            />
          </div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={24}>
              <FormFw
                  name="formSumas"
                  getParentApi={pageApi.getApi}
                  config={form_sumas}
              />
              </Col>
          </Row>
        </div> 
      </>
    ); 

  }
  }

export default ResumenCompraSection